import axios from "axios";
import { encryptData, decryptData, decryptObjectProperties } from "../utils/encryption";

const TRANS_URL = process.env.REACT_APP_TRANSACTION_API_URL;

export const addEnquiryTender = async (enquiryData) => {
    let url = `${TRANS_URL}/enquirytender/addenquirytender`;
    const response = await axios
        .post(url, enquiryData)
        .then(function (resp) {
            return resp;
        })
        .catch(function (error) {
            console.log("error => ", error);
            return { data: { message: "Unable to process request", status: false } };
        });
    return response.data;
};

export const addEnquiryTenderMail = async (enquiryData) => {
    let url = `${TRANS_URL}/enquirytender/addenquirytendermail`;
    const response = await axios
        .post(url, enquiryData)
        .then(function (resp) {
            return resp;
        })
        .catch(function (error) {
            console.log("error => ", error);
            return { data: { message: "Unable to process request", status: false } };
        });
    return response.data;
};

export const updateEnquiryStatus = async (enquiryNumber, status) => {
    let url = `${TRANS_URL}/enquirytender/updatestatus`;
    const response = await axios
        .post(url, { EnquiryNumber: enquiryNumber, EnquiryStatus: status })
        .then(function (resp) {
            return resp;
        })
        .catch(function (error) {
            console.log("error => ", error);
            return { data: { message: "Unable to update status", status: false } };
        });
    return response.data;
};

export async function getAllEnquiryTenders() {
    const response = await axios
        .get(TRANS_URL + "/enquirytender/getallenquirytenders")
        .then(function (resp) {
            return resp;
        })
        .catch(function (error) {
            console.log("error => ", error);
            return { data: [] };
        });
    return response.data;
}

export async function getAllEnquiryTendersActive() {
    const response = await axios
        .get(TRANS_URL + "/enquirytender/getallenquirytendersactive")
        .then(function (resp) {
            return resp;
        })
        .catch(function (error) {
            console.log("error => ", error);
            return { data: [] };
        });
    return response.data;
}

export const deleteEnquiryTender = async (enquiryNumber) => {
    let url = `${TRANS_URL}/enquirytender/deleteenquirytender`;
    const response = await axios
        .post(url, { EnquiryNumber: enquiryNumber })
        .then(function (resp) {
            return resp;
        })
        .catch(function (error) {
            console.log("error => ", error);
            return { data: { message: "Unable to delete request", status: false } };
        });
    return response.data;
};

export const linkCustomersToEnquiry = async (enquiryNumber, customerData) => {
    let url = `${TRANS_URL}/enquirytender/linkcustomers`;
    const response = await axios
        .post(url, { EnquiryNumber: enquiryNumber, ...customerData })
        .then(function (resp) {
            return resp;
        })
        .catch(function (error) {
            console.log("error => ", error);
            return { data: { message: "Unable to link customers", status: false } };
        });
    return response.data;
};

export const delinkCustomersFromEnquiry = async (enquiryNumber) => {
    let url = `${TRANS_URL}/enquirytender/delinkcustomers`;
    const response = await axios
        .post(url, { EnquiryNumber: enquiryNumber })
        .then(function (resp) {
            return resp;
        })
        .catch(function (error) {
            console.log("error => ", error);
            return { data: { message: "Unable to de-link customers", status: false } };
        });
    return response.data;
};

